import React from 'react';
import { useNavigate } from 'react-router-dom';
import GlowCard from '../components/GlowCard';

const S = '#00F5A0';
const G = '#8892A4';

const CheckIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={S} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 6L9 17l-5-5" />
  </svg>
);

const AccountDeletedPage = () => {
  const navigate = useNavigate();

  return (
    <div style={{
      minHeight: '100vh',
      background: '#0A1628',
      color: '#fff',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 16,
    }}>
      <div style={{ width: '100%', maxWidth: 480 }}>
        <GlowCard variant="card" style={{ padding: '32px 28px', textAlign: 'center' }}>
          <div style={{
            width: 44,
            height: 44,
            borderRadius: 10,
            background: 'rgba(0,245,160,0.1)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 20px',
          }}>
            <CheckIcon />
          </div>

          <h1 style={{ margin: '0 0 16px', fontSize: 20, fontWeight: 700, color: '#fff' }}>
            Compte supprimé
          </h1>

          <p style={{ margin: '0 0 16px', fontSize: 14, color: G, lineHeight: 1.6 }}>
            Votre compte SafeHeir a été supprimé définitivement.
          </p>
          <p style={{ margin: '0 0 16px', fontSize: 14, color: G, lineHeight: 1.6 }}>
            Toutes vos données personnelles ont été effacées conformément au RGPD
            (article 17). Une trace horodatée de cette suppression est conservée cinq
            ans à des fins probatoires, sans aucune donnée personnelle.
          </p>
          <p style={{ margin: '0 0 28px', fontSize: 14, color: G, lineHeight: 1.6 }}>
            Merci de nous avoir fait confiance.
          </p>

          <button
            onClick={() => navigate('/')}
            style={{
              background: S,
              color: '#0A1628',
              border: 'none',
              borderRadius: 8,
              padding: '10px 24px',
              fontWeight: 700,
              fontSize: 14,
              cursor: 'pointer',
            }}
          >
            Retour à l'accueil
          </button>
        </GlowCard>
      </div>
    </div>
  );
};

export default AccountDeletedPage;
